(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookies-pageload-popup-notice"] && !Shopify.designMode) return;
  try {
    
/** document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("noticePopup");
  const closeBtn = document.getElementById("closeNoticePopup");
  const closeX = document.getElementById("closePopupX");
  const understandBtn = document.getElementById("understandPopup");

  // Show popup
  popup.style.display = "flex";

  // Detect locale from URL path
  const path = window.location.pathname.toLowerCase();
  if (path.startsWith("/ja")) {
    understandBtn.textContent = "理解しました"; // Japanese
  } else if (path.startsWith("/zh")) {
    understandBtn.textContent = "我明白了"; // Chinese
  } else {
    understandBtn.textContent = "UNDERSTAND"; // Default English
  }

  // Close popup actions
  function closePopup() {
    popup.style.display = "none";
  }

  closeBtn.addEventListener("click", closePopup);
  closeX.addEventListener("click", closePopup);
  understandBtn.addEventListener("click", closePopup);
}); **/

document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("noticePopup");
  const closeBtn = document.getElementById("closeNoticePopup");
  const closeX = document.getElementById("closePopupX");
  const understandBtn = document.getElementById("understandPopup");

  // Pages to exclude (use the pathname, e.g., '/collections', '/pages/contact')
  const excludedPages = [
    '/pages/download', '/pages/portal', '/portal', '/products/terra-pro-ad', '/pages/tgs2026-guide'
  ];

  // Check if current page is excluded
  const currentPath = window.location.pathname.toLowerCase();
  const isExcluded = excludedPages.some(path => currentPath.startsWith(path));

  if (!isExcluded && !sessionStorage.getItem("noticePopupShown")) {
    // Show popup
    popup.style.display = "flex";

    // Set locale-based button text
    if (currentPath.startsWith("/ja")) {
      understandBtn.textContent = "理解しました"; // Japanese
    } else if (currentPath.startsWith("/zh")) {
      understandBtn.textContent = "我明白了"; // Chinese
    } else {
      understandBtn.textContent = "UNDERSTAND"; // Default English
    }

    function closePopup() {
      popup.style.display = "none";
      sessionStorage.setItem("noticePopupShown", "true");
    }

    closeBtn.addEventListener("click", closePopup);
    closeX.addEventListener("click", closePopup);
    understandBtn.addEventListener("click", closePopup);
  }
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["every-pageload-popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("np2-popup");
  const closeBtn = document.getElementById("np2-close-main-btn");
  const closeX = document.getElementById("np2-close-x");
  const understandBtn = document.getElementById("np2-understand");

  popup.style.display = "flex";

  // Detect locale
  const path = window.location.pathname.toLowerCase();
  if (path.startsWith("/ja")) {
    understandBtn.textContent = "理解しました";
  } else if (path.startsWith("/zh")) {
    understandBtn.textContent = "我明白了";
  }

  function closePopup() {
    popup.style.display = "none";
  }

  closeBtn.addEventListener("click", closePopup);
  closeX.addEventListener("click", closePopup);
  understandBtn.addEventListener("click", closePopup);
});

  } catch(e) { console.error(e); }
})();
})();
